import { render, staticRenderFns } from "./AccountInsuranceBridgeDetail.vue?vue&type=template&id=74882798&"
import script from "./AccountInsuranceBridgeDetail.vue?vue&type=script&lang=js&"
export * from "./AccountInsuranceBridgeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports